// Shared by the editor and the game worker: a plan never mutates its snapshot.
const footprint = item => ({
    x: Number(item.x), y: Number(item.y),
    width: Number(item.rotation) % 2 ? item.height : item.width,
    height: Number(item.rotation) % 2 ? item.width : item.height
})
const overlaps = (a, b) => a.x < b.x + b.width && a.x + a.width > b.x && a.y < b.y + b.height && a.y + a.height > b.y
const onGround = (item, grounds) => {
    const rect = footprint(item)
    if (![rect.x, rect.y, rect.width, rect.height].every(Number.isInteger) || rect.width < 1 || rect.height < 1 || rect.width > 100 || rect.height > 100)
        return false
    for (let x = rect.x; x < rect.x + rect.width; x++)
        for (let y = rect.y; y < rect.y + rect.height; y++)
            if (!grounds.some(ground => { const g = footprint(ground); return x >= g.x && y >= g.y && x < g.x + g.width && y < g.y + g.height }))
                return false
    return true
}
const simulatePlan = (snapshot, operations = []) => {
    if (!snapshot || !Array.isArray(operations) || operations.length > 100)
        throw new Error('Plan invalid sau prea mare (maximum 100 de modificări).')
    const buildings = snapshot.buildings.map(item => ({ ...item }))
    const storage = snapshot.storage.map(item => ({ ...item }))
    operations.forEach((op, index) => {
        const fail = message => { throw new Error(`Modificarea ${index + 1}: ${message}`) }
        if (!op || !['move', 'store', 'place', 'district'].includes(op.type))
            fail('acțiune necunoscută.')
        let item = buildings.find(entry => entry.key === op.key)
        if (op.type === 'place') {
            const stored = storage.find(entry => entry.key === op.storageKey)
            if (!stored || stored.amount < 1 || !stored.placeable)
                fail('obiectul nu mai este disponibil în stocare.')
            stored.amount--
            item = { ...stored, key: `planned:${index}`, objectId: null, districtId: -1, category: 'buildings', planned: true }
            buildings.push(item)
        } else if (!item || item.planned || !item.movable) {
            fail('obiectul nu poate fi modificat.')
        }
        if (op.type === 'store') {
            if (!item.storeable || (item.districtSlots > 0 && buildings.some(entry => entry.districtId === item.districtType)))
                fail('obiectul nu poate fi stocat sau districtul nu este gol.')
            buildings.splice(buildings.indexOf(item), 1)
            storage.push({ ...item, key: `pending:${item.key}`, amount: 1, placeable: true, pendingStorage: true })
            return
        }
        if (op.type === 'district') {
            const district = buildings.find(entry => entry.key === op.districtKey && entry.districtSlots > 0)
            if (!district || district.key === item.key || item.districtSlots > 0 || !item.allowedDistricts?.includes(district.districtType))
                fail('district incompatibil.')
            if (buildings.filter(entry => entry.districtId === district.districtType && entry.key !== item.key).length >= district.districtSlots)
                fail('districtul nu are locuri libere.')
            Object.assign(item, { districtId: district.districtType, x: -1, y: -1 })
            return
        }
        if (![op.x, op.y, op.rotation].every(Number.isInteger) || ![0, 1].includes(op.rotation))
            fail('coordonate sau rotație invalide.')
        if (!item.rotatable && op.rotation !== Number(item.rotation || 0))
            fail('obiectul nu poate fi rotit.')
        Object.assign(item, { x: op.x, y: op.y, rotation: op.rotation, districtId: -1 })
        if (!onGround(item, snapshot.grounds))
            fail('amplasarea depășește terenul deținut.')
        if (buildings.some(other => other.key !== item.key && other.category === 'buildings' && other.districtId < 0 && overlaps(footprint(item), footprint(other))))
            fail('amplasarea se suprapune cu altă clădire.')
    })
    return { ...snapshot, buildings, storage }
}
export { footprint, overlaps, onGround, simulatePlan }
